import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=ec0af592&"
import script from "./ProjectDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports